// extracted by mini-css-extract-plugin
export default {"container":"ShareLink_container__8VBHN"};